import { api } from "../api";

/**
 * updateUserByCustomer - Function that updates on database an access status of an user by id and customer id  
 * /users/{customerId}/{id}/{status}  
 * method PUT  
 * @async-function
 */
const updateUserStatusById = async (token: string, id: number, customerId: number, status: string) => {
    const response = await api.put(
        `/users/${customerId}/${id}/${status}`, {}, {
             headers: { 'Authorization': `Bearer ${token}` }
        });
    return response;
};
export default updateUserStatusById;
